import { backdropClasses } from "@mui/material/Backdrop";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiDialog = {
	styleOverrides: {
		paper: ({ theme }) => ({
			margin: theme.spacing(1),
			[theme.breakpoints.up("sm")]: {
				margin: theme.spacing(4),
			},
		}),
		root: {
			[`& .${backdropClasses.root}:not(.${backdropClasses.invisible})`]: {
				backdropFilter: "blur(8px)",
			},
		},
	},
} satisfies Components<Theme>["MuiDialog"];
